export { default, StatusChip } from './DayDetailBody';
